import React from "react"
import {
  DialogContent,
  Box,
  Typography,
  List,
  ListItem,
  styled,
} from "@mui/material"
import { useNavigate } from "react-router-dom"
import { useTranslation } from "react-i18next"

import { useAppDispatch } from "redux/hooks"
import { closeDialog } from "redux/features/dialog/dialogSlice"
import Close from "components/ui/ModalClose"
import { HELP_WHY_MATCH } from "config"

type Props = {
  type: "how" | "why" | "wherefore" | "what"
}

type ItemType = {
  title: string
}

const HelpModal = ({ type }: Props) => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const { t } = useTranslation()

  const items = t(`features.welcome.help.${type}.items`)
  const isList = items.length > 0

  const handleClose = () => {
    dispatch(closeDialog())
    navigate("/")
  }

  const renderContent = (type: string) => {
    const content = t(`features.welcome.help.${type}.description`, {
      link: `<a href=${HELP_WHY_MATCH}>
        ${t("features.welcome.help.how.link.title")}
      </Link>`,
    })

    return <span dangerouslySetInnerHTML={{ __html: content }} />
  }

  return (
    <DialogContent>
      <Close onClick={handleClose} />
      <Container>
        <Title variant="h4">{t(`features.welcome.help.${type}.title`)}</Title>
        <Content>{renderContent(type)}</Content>
        {isList && (
          <DescriptionList>
            {items.map((item: ItemType, index: number) => (
              <DescriptionListItem key={index}>
                {item.title}
              </DescriptionListItem>
            ))}
          </DescriptionList>
        )}
      </Container>
    </DialogContent>
  )
}

export default HelpModal

const Container = styled(Box)(() => ({
  margin: "0",
  padding: "0",
}))

const Title = styled(Typography)(() => ({
  textAlign: "center",
  margin: "0 0 12px 0",
}))

const Content = styled(Box)(() => ({
  margin: "0",
  padding: "0",
}))

export const DescriptionList = styled(List)(() => ({
  listStyle: "disc",
  margin: "0 0 0 20px",
}))

export const DescriptionListItem = styled(ListItem)(() => ({
  display: "list-item",
  fontSize: "0.875rem",
  fontWeight: 500,
  margin: "0",
  padding: "3px 0",
}))
